"use client";
import Link from "next/link";
import { useState, useEffect } from "react";
import ThemeToggler from "./ThemeToggler";
import DesktopNav from "./DesktopNav";
import MobileNav from "./MobileNav";

const Header = () => {
  const [navbarOpen, setNavbarOpen] = useState(false);
  const [sticky, setSticky] = useState(false);

  const handleStickyNavbar = () => {
    setSticky(window.scrollY >= 80);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleStickyNavbar);
    return () => window.removeEventListener("scroll", handleStickyNavbar);
  }, []);

  useEffect(() => {
    document.body.style.overflow = navbarOpen ? "hidden" : "auto";
  }, [navbarOpen]);

  return (
    <>
      <header
        className={`fixed top-0 left-0 z-50 w-full transition-all duration-300 ${
          sticky
            ? "dark:bg-gray-dark bg-white/90 shadow-md backdrop-blur-md"
            : "bg-transparent"
        }`}
      >
        <div className="container">
          <div className="flex items-center justify-between px-4 py-4 md:py-2 lg:px-6">
            <Link
              href="/"
              className="block bg-gradient-to-r from-blue-400 via-blue-500 to-blue-700 bg-clip-text text-xl font-bold text-transparent"
            >
              Devkin Technology
            </Link>
            <DesktopNav />
            <div className="flex items-center space-x-4">
              <Link
                href="/signin"
                className="hover:text-primary hidden text-base font-medium text-gray-700 md:block dark:text-gray-300 dark:hover:text-white"
              >
                Sign In
              </Link>
              <Link
                href="/signup"
                className="bg-primary hover:bg-primary/90 hidden rounded-md px-5 py-2 text-base font-medium text-white shadow-md transition md:block"
              >
                Sign Up
              </Link>
              <ThemeToggler />
              <button
                onClick={() => setNavbarOpen((prev) => !prev)}
                className="block focus:outline-none lg:hidden"
              >
                <div className="space-y-1">
                  <span
                    className={`block h-0.5 w-6 bg-current transition-all ${
                      navbarOpen ? "translate-y-2 rotate-45" : ""
                    }`}
                  />
                  <span
                    className={`block h-0.5 w-6 bg-current transition-all ${
                      navbarOpen ? "opacity-0" : ""
                    }`}
                  />
                  <span
                    className={`block h-0.5 w-6 bg-current transition-all ${
                      navbarOpen ? "-translate-y-2 -rotate-45" : ""
                    }`}
                  />
                </div>
              </button>
            </div>
          </div>
        </div>
      </header>
      <MobileNav isOpen={navbarOpen} onClose={() => setNavbarOpen(false)} />
    </>
  );
};

export default Header;
